export default "__VITE_ASSET__Cn7rxae6__"